import { createElement } from 'react';
import './index.scss';
import { Switch as NextSwitch } from '@alifd/next';
const Switch = ({ disabled, size, ...otherProps }) => {
    const _otherProps = otherProps || {};
    return (createElement("div", { className: "switch", ..._otherProps },
        createElement(NextSwitch, { size: size, disabled: disabled })));
};
Switch.displayName = 'Switch';
export default Switch;
